import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CheckedButton = styled(ButtonBase)(({ theme }) => ({
  backgroundColor: '#58147F',
  color: '#FAFCFF',
  borderRadius: '4px',
  width: '62px',
  height: '32px',
  fontSize: '18px',
  display: 'flex',
  gap: '4px',
  '&:hover': {
    backgroundColor: '#58147FB3',
  },
  [theme.breakpoints.down('xl')]: {
    width: '63px',
  },
}));

export const AlertButton = styled(ButtonBase)(({ theme }) => ({
  backgroundColor: '#FF872E',
  color: '#FAFCFF',
  borderRadius: '4px',
  width: '62px',
  height: '32px',
  fontSize: '18px',
  display: 'flex',
  gap: '4px',
  '&:hover': {
    backgroundColor: '#FF872EB3',
  },
  [theme.breakpoints.down('xl')]: {
    width: '63px',
  },
}));
